import React from 'react';
import {NavLink} from 'react-router-dom';


import * as dateUtils from '../../../../utils/dateUtils';
import * as styleUtils from '../../../../utils/styleUtils';

import IconLinkedin from '../../../../public/images/icons/icon-linkedin.svg';
import IconTwitter from '../../../../public/images/icons/icon-twitter.svg';
import hasRole from '../../../contexts/Auth/hooks/hasRole';
import {I18nMessage} from '../../../contexts/I18n';
import {assetUrl} from '../../../../utils/cdnUtils';
import {authConstants} from '../../../contexts/Auth';
import {buyConstants} from '../../../modules/Buy';
import {staticConstants} from '../../../modules/Static';
import {useKeycloak} from '@react-keycloak/web';

import styles from './Footer.scss';


const NAV_ITEMS = [
    {
        className: styles.logoFooter,
        content: (
            <img
                alt={'Back to home'}
                height={'30'}
                src={assetUrl('/images/logo-full.svg')}
                width={'87'}
            />
        ),
        id: 'home',
        path: staticConstants.NAV_HOME
    },
    {
        id: 'buy',
        path: buyConstants.NAV_BUY_OVERVIEW_PAGE,
        requiredRole: authConstants.ROLE_FEATURE_SEARCH
    },
    {
        id: 'imprint',
        path: staticConstants.NAV_IMPRINT
    },
    {
        id: 'termsConditions',
        path: staticConstants.NAV_TERMS_CONDITIONS
    },
    {
        id: 'privacy',
        path: staticConstants.NAV_PRIVACY
    }
];


function SlimFooter() {

    const {keycloak} = useKeycloak();
    const eligibleNavItems = NAV_ITEMS.filter(item => !item.requiredRole || hasRole(item.requiredRole));

    return (
        <footer className={styleUtils.toClasses(styles.pageFooter, keycloak.authenticated ? styles.loggedIn : null)}>
            <div className={'container'}>

                <ul>

                    {eligibleNavItems.map(({className, content, id, labelValues, path}) => (
                        <li
                            className={className}
                            key={id}
                        >
                            <NavLink
                                aria-current={'page'}
                                aria-label={`Footer nav link ${id}`}
                                to={path}
                            >
                                {content || (
                                    <I18nMessage
                                        id={`footer.nav.${id}`}
                                        values={labelValues || {}}
                                    />
                                )}
                            </NavLink>
                        </li>
                    ))}

                    <li className={styles.socialMedia}>
                        <a
                            className={styles.twitter}
                            href={staticConstants.NAV_TWITTER}
                            target='_blank'
                        >
                            <IconTwitter/>
                        </a>
                        <a
                            className={styles.linkedin}
                            href={staticConstants.NAV_LINKEDIN}
                            target='_blank'
                        >
                            <IconLinkedin/>
                        </a>
                    </li>

                </ul>

                <div className={styles.copyright}>
                    <I18nMessage
                        id={'footer.copyright'}
                        values={{
                            year: dateUtils.today().toFormat('y')
                        }}
                    />
                    <br/>
                    <I18nMessage id={'footer.copyright.rights'}/>
                    <br/>
                    <div className={styles.socialMedia}>
                        <a
                            className={styles.twitter}
                            href={staticConstants.NAV_TWITTER}
                            target='_blank'
                        >
                            <IconTwitter/>
                        </a>
                        <a
                            className={styles.linkedin}
                            href={staticConstants.NAV_LINKEDIN}
                            target='_blank'
                        >
                            <IconLinkedin/>
                        </a>
                    </div>
                </div>

            </div>
        </footer>
    );
}


export default SlimFooter;
